<style lang="less" scoped>
@import "../../../../styles/public/public.less";
.timelinelabel {
  width: 3vw;
  // margin-top: -1.3vw;
  text-align: center;
}
.statustab {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-right: 0.2vw;
  margin-top: -0.4vw;
  margin-bottom: 0.2vw;
  align-items: center;
}
</style>
<template>
  <div style="height:100%">
    <Col span="24" style="height:98%;overflow-y: auto;width: 303px;margin-left:-20px;">
      <div v-show="hasdata">
        <div style="margin-top: 21px;">
          <div v-for="(item,index) in statuslist" :key="index" style="width:100%;">
            <Row style="margin:0 auto;">
              <Col span="3" style>
                <div style="text-align: center;">
                  <img src="../../../../../static/images/xz2.png" style="width:1vw;height:1vw" />
                  <div
                    style="width: 2px; height:10vh;border-left: 1px dashed #15A37D;margin:0 auto;margin-top: -0.4vw;"
                  ></div>
                </div>
              </Col>
              <Col span="21" class="Colrightpanel2">
                <div class="statustab">
                  <div>
                    <p style="font-weight: bold; font-size: 15px">{{item.CREATETIME}}</p>
                  </div>
                  <div>
                    <div
                      class="timelinelabel"
                      v-bind:style="'color:white;width:95px;padding:2px 4px;background:' + item.color"
                    >
                      <span>{{item.STEPNAME}}</span>
                    </div>
                  </div>
                </div>
                <!-- <Row >
                                    <Col span="24" style="padding:0px 4px;">

                                    </Col>
                </Row>-->
                <Row style="color:#000;font-size:14px;">
                  <!-- <Col span="24" style="padding-top:0px;padding-left:4px;">
                                    <p>{{item.REMARK}}</p>
                  </Col>-->
                  <Col span="24" style="padding:5px 15px 5px 4px;">
                    <p>意见:{{item.ADVICE}}</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div
        v-show="!hasdata"
        class="display_row_jc_ac"
        style="height:100%;margin-left:10px;padding-left: 40px;"
      >
        <img src="../../../../../static/images/暂无数据横.png" />
      </div>
    </Col>
  </div>
</template>

<script>
import bus from "../../../../app/event";
export default {
  data() {
    return {
      hasdata: false,
      statuslist: [
        //   {
        //     CREATETIME:'20190708T18:06:02',
        //     color:'green',
        //     STEPNAME:'验收初审退回',
        //     REMARK:'通过',
        //     ADVICE:'修改',
        //   },
        //   {
        //     CREATETIME:'20190708T18:06:02',
        //     color:'green',
        //     STEPNAME:'验收初审退回',
        //     REMARK:'通过',
        //     ADVICE:'修改',
        //   },
        //   {
        //     CREATETIME:'20190708T18:06:02',
        //     color:'green',
        //     STEPNAME:'验收初审退回',
        //     REMARK:'通过',
        //     ADVICE:'修改',
        //   }
      ]
    };
  },
  methods: {
    getInfo(ID, AOTHOR_ID) {
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=listprodetail",
          {
            ID,
            AOTHOR_ID
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.statuslist = [];
            if (res.data.length == 0) {
              this.$Message.info("暂无数据");
              this.hasdata = false;
              return;
            }
            this.hasdata = true;
            res.data.forEach(el => {
              el.color = "#80bb80";
              el.CREATETIME = el.CREATETIME.replace("T", " ");
              this.statuslist.push(el);
            });
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    }
  },
  mounted() {
    bus.$on("getProId", this.getInfo);
  },
  beforeDestroy() {
    bus.$off("getProId");
  }
};
</script>



// WEBPACK FOOTER //
// project_status.vue?3668ee7d